import { UserButton } from '@clerk/nextjs';
import clsx from 'clsx';
import { useState } from 'react';
import { BusinessSelectorModal } from '~/components/business/BusinessSelectorModal';
import { StreamChatProvider } from '~/react_context/StreamChatContext';
import { useUserContext } from '~/react_context/UserContext';
import { useNavStore } from '~/stores/nav.store';
import { FAIcon } from '../utils/FAIcons';
import { NavChatButton } from './NavChatButton';
import type { NavUserProps } from './NavPropTypes';

export const NavBottom = ({ borderColor = 'border-glazier-navy-500' }: NavUserProps) => {
	const { collapsedNav } = useNavStore();
	const { businessName, enableCompanyChat, hasMultipleBusinesses } = useUserContext();
	const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);

	return (
		<>
			<div
				className={clsx(`flex shrink-0 border-t ${borderColor} p-4`, {
					'flex-col justify-center items-center space-y-2': collapsedNav,
					'justify-between items-center': !collapsedNav,
				})}
			>
				<div className={clsx('flex items-center', { 'flex-col space-y-2': collapsedNav, 'space-x-2': !collapsedNav })}>
					<UserButton showName={false} />
					{hasMultipleBusinesses && !collapsedNav && (
						<>
							<button
								onClick={() => setIsBusinessModalOpen(true)}
								className="p-2 rounded-md hover:bg-gray-100 transition-colors text-white hover:text-gray-900"
								title="Switch Business"
							>
								<FAIcon icon="people-arrows-left-right" prefix="fad" className="h-5 w-5" />
							</button>
							{businessName && (
								<div className="text-xs text-gray-500 overflow-hidden text-ellipsis w-40 whitespace-nowrap">{businessName}</div>
							)}
						</>
					)}
				</div>
				{enableCompanyChat && !collapsedNav && (
					<StreamChatProvider>
						<NavChatButton />
					</StreamChatProvider>
				)}
			</div>

			{/* Business Selector Modal */}
			<BusinessSelectorModal isOpen={isBusinessModalOpen} onClose={() => setIsBusinessModalOpen(false)} />
		</>
	);
};
